import { createSelector } from 'reselect';
import {
  DefaultIntegrationImportErrorsParams,
  DefaultIntegrationImportParams,
  IntegrationImportErrorResult,
  IntegrationImportErrorsParams,
  IntegrationImportErrorsState,
  IntegrationImportParams,
  IntegrationImportResult,
  IntegrationImportState
} from './integration-imports.interface';
import {
  GET_INTEGRATION_IMPORT_ERRORS_SUCCESS,
  GET_INTEGRATION_IMPORTS_SUCCESS,
  IntegrationImportActions,
  IntegrationImportErrorsActions,
  SET_INTEGRATION_IMPORT_ERRORS_PARAMS,
  SET_INTEGRATION_IMPORTS_PARAMS
} from './integration-imports.actions';
import { ActionReducerMap } from '@ngrx/store';

export const importsInitialState: IntegrationImportState = {
  data: {
    data: [],
    total: 0
  },
  params: new DefaultIntegrationImportParams()
};

export const importErrorsInitialState: IntegrationImportErrorsState = {
  data: {
    data: [],
    total: 0
  },
  params: new DefaultIntegrationImportErrorsParams(null)
};

export function integrationImportsReducer(
  state: IntegrationImportState = importsInitialState,
  action: IntegrationImportActions
): IntegrationImportState {
  switch (action.type) {
    case GET_INTEGRATION_IMPORTS_SUCCESS:
      return {
        ...state,
        data: action.payload
      };
    case SET_INTEGRATION_IMPORTS_PARAMS:
      return {
        ...state,
        params: action.payload
      };
    default: {
      return state;
    }
  }
}

export function integrationImportErrorsReducer(
  state: IntegrationImportErrorsState = importErrorsInitialState,
  action: IntegrationImportErrorsActions
): IntegrationImportErrorsState {
  switch (action.type) {
    case GET_INTEGRATION_IMPORT_ERRORS_SUCCESS:
      return {
        ...state,
        data: action.payload
      };
    case SET_INTEGRATION_IMPORT_ERRORS_PARAMS:
      return {
        ...state,
        params: action.payload
      };
    default: {
      return state;
    }
  }
}

interface IntegrationImportStateWrapper {
  integrationImports: IntegrationImportState;
  integrationImportErrors: IntegrationImportErrorsState;
}

export const integrationImportReducers: ActionReducerMap<IntegrationImportStateWrapper> = {
  integrationImports: integrationImportsReducer,
  integrationImportErrors: integrationImportErrorsReducer
};

export const getIntegrationImports = (state): IntegrationImportStateWrapper => state.integrationImports;

export const getIntegrationImportsData = (state: IntegrationImportStateWrapper): IntegrationImportResult =>
  state.integrationImports.data;
export const getIntegrationImportsParams = (state: IntegrationImportStateWrapper): IntegrationImportParams =>
  state.integrationImports.params;
export const getIntegrationImportsDataSelector = createSelector(getIntegrationImports, getIntegrationImportsData);
export const getIntegrationImportsParamsSelector = createSelector(getIntegrationImports, getIntegrationImportsParams);

export const getIntegrationImportErrorsData = (state: IntegrationImportStateWrapper): IntegrationImportErrorResult =>
  state.integrationImportErrors.data;
export const getIntegrationImportErrorsParams = (state: IntegrationImportStateWrapper): IntegrationImportErrorsParams =>
  state.integrationImportErrors.params;
export const getIntegrationImportErrorsDataSelector = createSelector(
  getIntegrationImports,
  getIntegrationImportErrorsData
);
export const getIntegrationImportErrorsParamsSelector = createSelector(
  getIntegrationImports,
  getIntegrationImportErrorsParams
);
